import toast from "react-hot-toast";
import axiosSetup from "../utils/axiosSetup";
import ResponseModel from "../models/response.model";

export const getWhatsappNumbers = async (): Promise<ResponseModel> => {
  const response = await axiosSetup.get("/whatsAppData/numbers");
  return response.data;
};

export const getWhatsappTemplate = async () => {
  try {
    const response = await axiosSetup.get("/whatsAppData/templates");

    return response.data.data;
  } catch (error: any) {
    toast.error("Unhandled error fetching WhatsApp templates:", error);
    throw error;
  }
};

export const getOneTemplate = async (id: any) => {
  try {
    const response = await axiosSetup.post(`/whatsAppData/getOneTemplate`, {
      id: id,
    });
    return response.data.data;
  } catch (error: any) {
    toast.error("Unhandled error fetching WhatsApp template by ID:", error);
    throw error;
  }
};

export const sendBulkMessage = async ({
  userPhoneNumber,
  templateName,
  languageCode,
  components,
}: {
  userPhoneNumber: string;
  templateName: string;
  languageCode: string;
  components: any[];
}) => {
  try {
    const response = await axiosSetup.post("/whatsAppData/sendToUser", {
      userPhoneNumber,
      templateName,
      languageCode,
      components,
    });
    if (response.data.message) {
      toast.success(response.data.message);
    }
    return response?.data;
  } catch (error: any) {
    return toast.error(error?.response?.data.details);
  }
};

export const getChats = async (chatId: string, page: number) => {
  try {
    const response = await axiosSetup.post(
      `/whatsAppData/fetchChats?page=${page}`,
      {
        chatId,
      },
    );
    return response?.data?.data;
  } catch (error: any) {
    toast.error("Unhandled error fetching WhatsApp chats:", error);
    throw error;
  }
};

export const sendTextMessage = async (
  sentTo: string,
  message: string,
  attachments: File[] = [],
) => {
  const formData = new FormData();
  formData.append("sentTo", sentTo);
  formData.append("message", message);

  // Append each attachment
  attachments.forEach((file) => {
    formData.append("attachments", file);
  });

  try {
    const response = await axiosSetup.post(
      "/whatsAppData/sendTextMessageToUser",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response?.data;
  } catch (error: any) {
    toast.error(error?.response?.data?.message || "Failed to send message");
    throw error;
  }
};

export const updateIsSeen = async (chatId: string) => {
  const response = await axiosSetup.put("/whatsAppData/updateSeen", {
    chatId,
  });
  return response.data;
};

export const getWhatsappChatList = async () => {
  const response = await axiosSetup.get(`/whatsAppData/fetchChatList`);
  return response.data.data;
};
